export default __webpack_public_path__ + "static/media/eg.0621dac2.svg";